import { render, staticRenderFns } from "./iconUnionPay.vue?vue&type=template&id=f5d55edc"
import script from "./iconUnionPay.vue?vue&type=script&lang=js"
export * from "./iconUnionPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports